import React from 'react';
import { string } from 'prop-types';

export const Salsify = ({ salsifyRichContent, parentId }) => {

  return (
    <div
      id={parentId}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: salsifyRichContent
      }}
    />
  );
};

Salsify.displayName = 'Salsify';

Salsify.propTypes = {
  salsifyRichContent: string.isRequired,
  parentId: string.isRequired
};